<template>
  <div>
    <AppHeader id="appHeader" v-bind:tags="tags"></AppHeader>
    <router-view :style="{'min-height': minHeight}" />
  </div>
</template>
<script>
import $ from 'jquery'
import AppHeader from '@/components/App/AppHeader'
export default {
  components: {
    AppHeader
  },
  data () {
    return {
      role: this.$store.getters.user.role,
      userId: this.$store.getters.user.id,
      minHeight: '0px'
    }
  },
  computed: {
    tags: function () {
      return [
        {
          text: '主頁',
          'to': {
            name: 'Home'
          }
        },
        {
          text: '我的檔案',
          'to': {
            name: 'Profile'
          }
        },
        {
          text: '我的班級',
          to: {
            name: 'ClassHome'
          },
          check: (r) => r.matched.some(route => route.name === 'Class')
        },
        {
          text: '學習資源',
          'to': {
            name: 'AllResources'
          },
          check: (r) => r.matched.some(route => route.name === 'Resources')
        }
      ]
    },
    isStudent: function () {
      return this.role === 'student'
    },
    isTeacher: function () {
      return this.role === 'teacher'
    }
  },
  mounted () {
    console.log(this)
    this.$nextTick(function () {
      let height = document.getElementById('appHeader') !== null ? document.getElementById('appHeader').offsetHeight : 0
      console.log(height)
      console.log(document.getElementById('root'))
      this.minHeight = `calc( 100vh - ${height}px )`
    })
  // },
  // beforeRouteEnter (to, from, next) {
  //   next(function (component) {
  //     console.log(component.tags)
  //     console.log(component.$route.matched)
  //     // console.log(component.tags.some(tag => tag.to.name === component.$route.name))
  //     // console.log(component.$route.name)
  //     // if (!component.tags.some(tag => tag.to.name === component.$route.name)) {
  //     //   component.$router.replace('/')
  //     // }
  //   })
  // },
  // beforeRouteUpdate (to, from, next) {
  //   console.log(this.tags.some(tag => tag.check ? tag.check(this.$route) : this.$route.matched.some(route => route.name === tag.to.name)))
  //   next()
  },
  updated () {
    console.log('update')
    $('html').css('overflow-y', 'auto')
  }
}
</script>
